var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12358 2.02157C8.57419 1.55911 8.57419 0.80931 8.12358 0.346847C7.67298 -0.115616 6.9424 -0.115616 6.4918 0.346847L0.337954 6.66264C0.112651 6.89387 0 7.19693 0 7.5C0 7.66057 0.0311371 7.81367 0.0875524 7.9533C0.14386 8.09297 0.227327 8.22382 0.337954 8.33736L6.4918 14.6532C6.9424 15.1156 7.67298 15.1156 8.12358 14.6532C8.57419 14.1907 8.57419 13.4409 8.12358 12.9784L3.93948 8.68421H18.8462C19.4834 8.68421 20 8.15402 20 7.5C20 6.84598 19.4834 6.31579 18.8462 6.31579H3.93948L8.12358 2.02157Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.18a015b41af1cfb00d85b260c9befb83.svg";
export { ForwardRef as ReactComponent };